// import * as React from 'react';
// import { useEffect, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { Grid, Box, Typography, Paper, Checkbox, FormControlLabel, TextField, CssBaseline, IconButton, InputAdornment, CircularProgress} from '@mui/material';
// import { createTheme, ThemeProvider } from '@mui/material/styles';
// import { Visibility, VisibilityOff } from '@mui/icons-material';
// import bgpic from "../../assets/designlogin.jpg"
// import { LightPurpleButton } from '../../components/buttonStyles';
// import { registerUser } from '../../redux/userRelated/userHandle';
// import styled from 'styled-components';
// import Popup from '../../components/Popup';

// const defaultTheme = createTheme();

// const AdminRegisterPage = () => {

//     const dispatch = useDispatch()
//     const navigate = useNavigate()

//     const { status, currentUser, response, error, currentRole } = useSelector(state => state.user);;

//     const [toggle, setToggle] = useState(false)
//     const [loader, setLoader] = useState(false)
//     const [showPopup, setShowPopup] = useState(false);
//     const [message, setMessage] = useState("");

//     const [emailError, setEmailError] = useState(false);
//     const [passwordError, setPasswordError] = useState(false);
//     const [adminNameError, setAdminNameError] = useState(false);
//     const [schoolNameError, setSchoolNameError] = useState(false);
//     const role = "Admin"

//     const handleSubmit = (event) => {
//         event.preventDefault();

//         const name = event.target.adminName.value;
//         const schoolName = event.target.schoolName.value;
//         const email = event.target.email.value;
//         const password = event.target.password.value;

//         if (!name || !schoolName || !email || !password) {
//             if (!name) setAdminNameError(true);
//             if (!schoolName) setSchoolNameError(true);
//             if (!email) setEmailError(true);
//             if (!password) setPasswordError(true);
//             return;
//         }

//         const fields = { name, email, password, role, schoolName }
//         setLoader(true)
//         dispatch(registerUser(fields, role))
//     };

//     const handleInputChange = (event) => {
//         const { name } = event.target;
//         if (name === 'email') setEmailError(false);
//         if (name === 'password') setPasswordError(false);
//         if (name === 'adminName') setAdminNameError(false);
//         if (name === 'schoolName') setSchoolNameError(false);
//     };

//     useEffect(() => {
//         if (status === 'success' || (currentUser !== null && currentRole === 'Admin')) {
//             navigate('/Admin/dashboard');
//         }
//         else if (status === 'failed') {
//             setMessage(response)
//             setShowPopup(true)
//             setLoader(false)
//         }
//         else if (status === 'error') {
//             console.log(error)
//         }
//     }, [status, currentUser, currentRole, navigate, error, response]);

//     return (
//         <ThemeProvider theme={defaultTheme}>
//             <Grid container component="main" sx={{ height: '100vh' }}>
//                 <CssBaseline />
//                 <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
//                     <Box
//                         sx={{
//                             my: 8,
//                             mx: 4,
//                             display: 'flex',
//                             flexDirection: 'column',
//                             alignItems: 'center',
//                         }}
//                     >
//                         <Typography variant="h4" sx={{ mb: 2, color: "#2c2143" }}>
//                             Admin Register
//                         </Typography>
//                         <Typography variant="h7">
//                             Create your own school by registering as an admin.
//                             <br />
//                             You will be able to add students and faculty and
//                             manage the system.
//                         </Typography>
//                         <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 2 }}>
//                             <TextField
//                                 margin="normal"
//                                 required
//                                 fullWidth
//                                 id="adminName"
//                                 label="Enter your name"
//                                 name="adminName"
//                                 autoComplete="name"
//                                 autoFocus
//                                 error={adminNameError}
//                                 helperText={adminNameError && 'Name is required'}
//                                 onChange={handleInputChange}
//                             />
//                             <TextField
//                                 margin="normal"
//                                 required
//                                 fullWidth
//                                 id="schoolName"
//                                 label="Create your school name"
//                                 name="schoolName"
//                                 autoComplete="off"
//                                 error={schoolNameError}
//                                 helperText={schoolNameError && 'School name is required'}
//                                 onChange={handleInputChange}
//                             />
//                             <TextField
//                                 margin="normal"
//                                 required
//                                 fullWidth
//                                 id="email"
//                                 label="Enter your email"
//                                 name="email"
//                                 autoComplete="email"
//                                 error={emailError}
//                                 helperText={emailError && 'Email is required'}
//                                 onChange={handleInputChange}
//                             />
//                             <TextField
//                                 margin="normal"
//                                 required
//                                 fullWidth
//                                 name="password"
//                                 label="Password"
//                                 type={toggle ? 'text' : 'password'}
//                                 id="password"
//                                 autoComplete="current-password"
//                                 error={passwordError}
//                                 helperText={passwordError && 'Password is required'}
//                                 onChange={handleInputChange}
//                                 InputProps={{
//                                     endAdornment: (
//                                         <InputAdornment position="end">
//                                             <IconButton onClick={() => setToggle(!toggle)}>
//                                                 {toggle ? (
//                                                     <Visibility />
//                                                 ) : (
//                                                     <VisibilityOff />
//                                                 )}
//                                             </IconButton>
//                                         </InputAdornment>
//                                     ),
//                                 }}
//                             />
//                             <Grid container sx={{ display: "flex", justifyContent: "space-between" }}>
//                                 <FormControlLabel
//                                     control={<Checkbox value="remember" color="primary" />}
//                                     label="Remember me"
//                                 />
//                             </Grid>
//                             <LightPurpleButton
//                                 type="submit"
//                                 fullWidth
//                                 variant="contained"
//                                 sx={{ mt: 3, mb: 2 }}
//                             >
//                                 {loader ? <CircularProgress size={24} color="inherit"/> : "Register"}
//                             </LightPurpleButton>
//                             <Grid container>
//                                 <Grid>
//                                     Already have an account?
//                                 </Grid>
//                                 <Grid item sx={{ ml: 2 }}>
//                                     <StyledLink to="/Adminlogin">
//                                         Log in
//                                     </StyledLink>
//                                 </Grid>
//                             </Grid>
//                         </Box>
//                     </Box>
//                 </Grid>
//                 <Grid
//                     item
//                     xs={false}
//                     sm={4}
//                     md={7}
//                     sx={{
//                         backgroundImage: `url(${bgpic})`,
//                         backgroundRepeat: 'no-repeat',
//                         backgroundColor: (t) =>
//                             t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
//                         backgroundSize: 'cover',
//                         backgroundPosition: 'center',
//                     }}
//                 />
//             </Grid>
//             <Popup message={message} setShowPopup={setShowPopup} showPopup={showPopup} />
//         </ThemeProvider>
//     );
// }

// export default AdminRegisterPage

// const StyledLink = styled(Link)`
//   margin-top: 9px;
//   text-decoration: none;
//   color: #7f56da;
// `;


import * as React from 'react';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import bgpic from "../../assets/designlogin.jpg";
import { LightPurpleButton } from '../../components/buttonStyles';
import { registerUser } from '../../redux/userRelated/userHandle';
import styled from 'styled-components';
import Popup from '../../components/Popup';

const AdminRegisterPage = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { status, currentUser, response, error, currentRole } = useSelector(state => state.user);

    const [toggle, setToggle] = useState(false);
    const [loader, setLoader] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [message, setMessage] = useState("");

    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [adminNameError, setAdminNameError] = useState(false);
    const [schoolNameError, setSchoolNameError] = useState(false);
    const role = "Admin";

    const handleSubmit = (event) => {
        event.preventDefault();

        const name = event.target.adminName.value;
        const schoolName = event.target.schoolName.value;
        const email = event.target.email.value;
        const password = event.target.password.value;

        if (!name || !schoolName || !email || !password) {
            if (!name) setAdminNameError(true);
            if (!schoolName) setSchoolNameError(true);
            if (!email) setEmailError(true);
            if (!password) setPasswordError(true);
            return;
        }

        const fields = { name, email, password, role, schoolName };
        setLoader(true);
        dispatch(registerUser(fields, role));
    };

    const handleInputChange = (event) => {
        const { name } = event.target;
        if (name === 'email') setEmailError(false);
        if (name === 'password') setPasswordError(false);
        if (name === 'adminName') setAdminNameError(false);
        if (name === 'schoolName') setSchoolNameError(false);
    };

    useEffect(() => {
        if (status === 'success' || (currentUser !== null && currentRole === 'Admin')) {
            navigate('/Admin/dashboard');
        }
        else if (status === 'failed') {
            setMessage(response);
            setShowPopup(true);
            setLoader(false);
        }
        else if (status === 'error') {
            console.log(error);
        }
    }, [status, currentUser, currentRole, navigate, error, response]);

    return (
        <div className="flex h-screen">
            <div className="w-full md:w-2/5 bg-white p-8 flex flex-col justify-center">
                <h2 className="text-3xl font-semibold text-purple-900 mb-4">Admin Register</h2>
                <p className="text-sm text-gray-700 mb-4">
                    Create your own school by registering as an admin.
                    <br />
                    You will be able to add students and faculty and manage the system.
                </p>
                <form onSubmit={handleSubmit} noValidate className="space-y-4">
                    <div>
                        <input
                            className={`w-full p-3 border rounded ${adminNameError ? 'border-red-500' : 'border-gray-300'}`}
                            id="adminName"
                            name="adminName"
                            placeholder="Enter your name"
                            autoComplete="name"
                            autoFocus
                            onChange={handleInputChange}
                        />
                        {adminNameError && <p className="text-red-500 text-sm">Name is required</p>}
                    </div>
                    <div>
                        <input
                            className={`w-full p-3 border rounded ${schoolNameError ? 'border-red-500' : 'border-gray-300'}`}
                            id="schoolName"
                            name="schoolName"
                            placeholder="Create your school name"
                            autoComplete="off"
                            onChange={handleInputChange}
                        />
                        {schoolNameError && <p className="text-red-500 text-sm">School name is required</p>}
                    </div>
                    <div>
                        <input
                            className={`w-full p-3 border rounded ${emailError ? 'border-red-500' : 'border-gray-300'}`}
                            id="email"
                            name="email"
                            placeholder="Enter your email"
                            autoComplete="email"
                            onChange={handleInputChange}
                        />
                        {emailError && <p className="text-red-500 text-sm">Email is required</p>}
                    </div>
                    <div className="relative">
                        <input
                            className={`w-full p-3 border rounded ${passwordError ? 'border-red-500' : 'border-gray-300'}`}
                            id="password"
                            name="password"
                            type={toggle ? 'text' : 'password'}
                            placeholder="Password"
                            autoComplete="current-password"
                            onChange={handleInputChange}
                        />
                        <div className="absolute top-1/2 right-3 transform -translate-y-1/2 cursor-pointer" onClick={() => setToggle(!toggle)}>
                            {toggle ? <Visibility /> : <VisibilityOff />}
                        </div>
                        {passwordError && <p className="text-red-500 text-sm">Password is required</p>}
                    </div>
                    <div className="flex items-center">
                        <input type="checkbox" className="mr-2" />
                        <label className="text-sm text-gray-700">Remember me</label>
                    </div>
                    <LightPurpleButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        className="w-full py-2 mt-2 mb-2"
                    >
                        {loader ? <div className="w-6 h-6 border-4 border-white border-t-transparent animate-spin rounded-full mx-auto" /> : "Register"}
                    </LightPurpleButton>
                    <div className="flex items-center text-sm">
                        <span>Already have an account?</span>
                        <StyledLink to="/Adminlogin" className="ml-2">Log in</StyledLink>
                    </div>
                </form>
            </div>
            <div
                className="hidden md:block md:w-3/5 bg-cover bg-center"
                style={{ backgroundImage: `url(${bgpic})` }}
            ></div>
            <Popup message={message} setShowPopup={setShowPopup} showPopup={showPopup} />
        </div>
    );
};

export default AdminRegisterPage;

const StyledLink = styled(Link)`
  margin-top: 9px;
  text-decoration: none;
  color: #7f56da;
`;
